export class Producto {
  guia?: string;
  guia_devolucion?: string;
  id_registro?: string;
  metodo_pago?: string;
  nombre_destinatario?: string;
  nombre_remitente?: string;
  nombre_responsable?: string;
  telefono_responsable?: number;
  transportadora?: string;
  url_responsable?: string;
  fecha_pedido?: string;
  estado_transportadora?: string;
  direccion_destinatario?: string;
  detalle_pedido?: string;
  ciudad_remitente?: string;
  ciudad_destinatario?: string;
}
